<div class="candidate-profile">
  <common-mojo-avatar
    [backgroundSize]="avatarBackground"
    [id]="candidate.candidateImageId"
    [initials]="candidate.initials"
    [label]="candidate.label"
    [routerLink]="['/candidates', candidate?.id]"
    [selectedPhotoShape]="selectedPhotoShape"
  ></common-mojo-avatar>
  <div class="details">
    <a
      [routerLink]="['/candidates', candidate?.id]"
      class="text-truncate mat-headline-6 mat-link candidate-name"
      data-cy="candidate-label-name"
    >{{ candidate?.visibleName }}</a>
    <ng-content
      (click)="$event?.stopPropagation()"
      select="[progress]"
    ></ng-content>
  </div>
  <ng-content
    class="menu"
    select="[menu]"
  ></ng-content>
</div>
